'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mplAuctionHouse = require('@metaplex-foundation/mpl-auction-house');
var Operation = require('../../../types/Operation.cjs');
var TransactionBuilder = require('../../../utils/TransactionBuilder.cjs');

// -----------------
// Operation
// -----------------

const Key = 'WithdrawFromFeeAccountOperation';

/**
 * Transfers funds from Auction House Fee Wallet to the Fee Withdrawal Destination Wallet.
 * By default Fee Withdrawal Destination Wallet is set to `metaplex.identity()`.
 *
 * ```ts
 * await metaplex
 *   .auctionHouse()
 *   .withdrawFromFeeAccount({ auctionHouse, amount };
 * ```
 *
 * @group Operations
 * @category Constructors
 */
const withdrawFromFeeAccountOperation = Operation.useOperation(Key);

/**
 * @group Operations
 * @category Types
 */

/**
 * @group Operations
 * @category Handlers
 */
const withdrawFromFeeAccountOperationHandler = {
  handle: async (operation, metaplex, scope) => withdrawFromFeeAccountBuilder(metaplex, operation.input, scope).sendAndConfirm(metaplex, scope.confirmOptions)
};

// -----------------
// Builder
// -----------------

/**
 * @group Transaction Builders
 * @category Inputs
 */

/**
 * Transfers funds from Auction House Fee Wallet to the Fee Withdrawal Destination Wallet.
 * By default Fee Withdrawal Destination Wallet is set to `metaplex.identity()`.
 *
 * ```ts
 * const transactionBuilder = metaplex
 *   .auctionHouse()
 *   .builders()
 *   .withdrawFromFeeAccount({ auctionHouse, amount });
 * ```
 *
 * @group Transaction Builders
 * @category Constructors
 */
const withdrawFromFeeAccountBuilder = (metaplex, params, options = {}) => {
  // Data.
  const {
    payer = metaplex.rpc().getDefaultFeePayer()
  } = options;
  const {
    auctionHouse,
    amount,
    instructionKey,
    authority = metaplex.identity()
  } = params;

  // Accounts.
  const accounts = {
    authority: auctionHouse.authorityAddress,
    feeWithdrawalDestination: auctionHouse.feeWithdrawalDestinationAddress,
    auctionHouse: auctionHouse.address,
    auctionHouseFeeAccount: auctionHouse.feeAccountAddress
  };

  // Withdraw From Fee Instruction.
  const withdrawFromFeeInstruction = mplAuctionHouse.createWithdrawFromFeeInstruction(accounts, {
    amount: amount.basisPoints
  });

  // Signers.
  return TransactionBuilder.TransactionBuilder.make().setFeePayer(payer)

  // Withdraw From Fee.
  .add({
    instruction: withdrawFromFeeInstruction,
    signers: [authority],
    key: instructionKey ?? 'withdrawFromFeeAccount'
  });
};

exports.withdrawFromFeeAccountBuilder = withdrawFromFeeAccountBuilder;
exports.withdrawFromFeeAccountOperation = withdrawFromFeeAccountOperation;
exports.withdrawFromFeeAccountOperationHandler = withdrawFromFeeAccountOperationHandler;
//# sourceMappingURL=withdrawFromFeeAccount.cjs.map
